import AtcFlightFare from './flight-fare-component';
import AtcFlightFareService from './flight-fare-service';
import AtcFlightRulesLinkModule from './../../flight-rules-link/flight-rules-link-module';
import './flight-fare.scss';

const MODULE_NAME = 'app.atc.flight.fare';
const module = angular.module(MODULE_NAME, [
        AtcFlightRulesLinkModule,
    ])
    .directive(AtcFlightFare.DIRECTIVE_NAME, AtcFlightFare)
    .service('atcFlightFareService', AtcFlightFareService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-fare/flight-fare-module.js